module.exports = __webpack_public_path__ + "static/assets/e44eff5452814806c025ff20fc208fa1.svg";